import { render } from "./UserAccount.vue?vue&type=template&id=10b42051&scoped=true"
import script from "./UserAccount.vue?vue&type=script&lang=js"
export * from "./UserAccount.vue?vue&type=script&lang=js"

import "./UserAccount.vue?vue&type=style&index=0&id=10b42051&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b42051"]])

export default __exports__